import React from 'react'
import {useLocation } from 'react-router-dom';
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { CircularProgress, Dialog, Divider,Grid,IconButton,makeStyles } from '@material-ui/core';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import {ModifyLiabilityDamageCoverage} from './ModifyLiabilityDamageCoverage'
import {ModifyLiabilityCoverage} from './ModifyLiabilityCoverage'
import {ModifyAdditionalCoverages} from './ModifyAdditionalCoverages'
import {ActionsSection} from './ActionsSection'
import './Modify.scss'
import PolicyLiabilityExtensionContext from '../../../../context/PolicyLiabilityExtensionContext'
import {ModificationContextStore} from '../../../../context/ModificationContext'
import ModifyNamedInsured from './ModifyNamedInsured';
import { ModifyPilotCertificationRating } from './ModifyPilotCertificationRating';
import {ModifyHoursLogged} from './ModifyHoursLogged';
import { SessionService } from "../../../../services/SessionService";
import { isMobile, MobileView, BrowserView } from 'react-device-detect'
import { Clear } from '@material-ui/icons';
import { useForm } from 'react-hook-form'



interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}
const useStyles = makeStyles((theme) => ({
        divider: {
        color:'white',
        },
    }));

export const ModifyPolicySection = ({insurance,isOpen,closeDialog,isRenewal}: PolicyAdditionalInsuredSectionProps) => {
    const location = useLocation()
    const modificationContext = React.useContext(ModificationContextStore) 
    const modificationObject = isRenewal ? modificationContext.subscription : modificationContext.insurance
    const [open, setOpen] = React.useState(isOpen)
    const classes = useStyles();
    const { register, control, handleSubmit, setValue, getValues } = useForm({
    mode: 'onChange',
    defaultValues: {
        total_hours_logged: '', // Initialize with an empty string or some default value
        ...insurance,
    },
});

React.useEffect(() => {
    // Log to check if insuredPersons data is available when the useEffect runs
    console.log("Insured Persons:", modificationContext.subscription.insuredPersons);
    
    if (modificationContext.subscription.insuredPersons && modificationContext.subscription.insuredPersons[0]) {
        // Set the value for total_hours_logged
        setValue('total_hours_logged', modificationContext.subscription.insuredPersons[0].totalHoursLogged || 100);
        
        // Log to verify that the value is being set correctly
        console.log("Set Value for total_hours_logged:", getValues('total_hours_logged'));
    }
}, [modificationContext.subscription.insuredPersons, setValue, getValues]);


    return (
    <React.Fragment>
        <Dialog
                BackdropProps={{style: {backgroundColor: 'white', opacity: isMobile ? 1 : 0.64}}}
                fullWidth
                fullScreen={isMobile}
                open={isOpen}
                onClose={closeDialog}
                PaperProps={{style: {backgroundColor: 'transparent', borderRadius: '10px' }}}
                maxWidth={'md'}
            >
            <div className="full-width midterm-modal-container">
                <div className="modify-title midterm-modal-title">
                    <div className='midterm-modal-title-text'>{isRenewal ? 'Edit renewal policy': 'Edit policy' }</div>
                    <IconButton onClick={() => closeDialog()} style={{marginRight: '2rem'}}>
                        <Clear/>
                    </IconButton>
                </div>
                <PolicyLiabilityExtensionContext>
                    {modificationContext.liabilityLimitOptions.length>0 ? <div className='midterm-modal-content'>
                    <ModifyNamedInsured isRenewal ={isRenewal} modificationObject={modificationObject} className="modify-section-component" insurance={insurance}/>
                    <Divider classes={{root: classes.divider}}/>
                    {isRenewal && 
                    <>
                    <ModifyPilotCertificationRating/>
                    <Divider classes={{root: classes.divider}}/>
                    </>}
                    <ModifyLiabilityCoverage  modificationObject={modificationObject} isRenewal ={isRenewal} className="modify-section-component" insurance={insurance}/>       
                    <Divider classes={{root: classes.divider}}/> 
                    <ModifyLiabilityDamageCoverage  modificationObject={modificationObject} isRenewal ={isRenewal} className="modify-section-component" insurance={insurance}/> 
                    <Divider classes={{root: classes.divider}}/>
                    {isRenewal && 
                    <>
                        <ModifyHoursLogged control={control} />
                    </>}   
                    </div> : 
                    <Grid container justifyContent='center' alignItems='center' className='margin-top-basic margin-bottom-basic' style={{flexGrow: 1}}><CircularProgress/></Grid>}
                    <div className='midterm-modal-actions-container'>
                        <ActionsSection
                            isRenewal={isRenewal}
                            closeDialog={closeDialog}
                            handleSubmit={handleSubmit}
                            getValues={getValues} // Pass getValues to retrieve form data
                        />
                    </div>
                </PolicyLiabilityExtensionContext>
            </div>
        </Dialog>
    </React.Fragment>)
}